import { useMutation, useQuery } from '@tanstack/react-query';

import {
  getNetworkSettings,
  postNetworkSettings,
  putNetworkSettings,
} from '../../services';

export const useUpdateNetworkSettings = () => {
  return useMutation({
    mutationKey: ['update_network_settings'],
    mutationFn: putNetworkSettings,
  });
};

export const useCreateNetworkSettings = () => {
  return useMutation({
    mutationKey: ['create_network_settings'],
    mutationFn: postNetworkSettings,
  });
};

export const useGetNetworkSettings = () => {
  return useQuery({
    queryKey: ['get_network_settings'],
    queryFn: getNetworkSettings,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
